export default __webpack_public_path__ + "static/media/cheese.06ee58e7.png";